import { c as _c } from "react/compiler-runtime";
import { Form, Formik, useFormikContext } from 'formik';
import { useContext, useState } from 'react';
import useSWR from 'swr';
import { ManagedTokenIntegrationConfigs } from '../../../../../../../typings/Integration.interface';
import { OutpostDestination, OutpostDestinationTypeField, OutpostDestinationTypeMetadata } from '../../../../../../../typings/outpost';
import APIMethodKeys from '../../../../client/APIMethodKeys';
import HookdeckAPIClient from '../../../../client/Hookdeck';
import field_formats from '../../../../utils/field-formatters';
import Button, { PlaceholderButton } from '../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../common/base/Card';
import Container from '../../../common/base/Container';
import Divider from '../../../common/base/Divider';
import Icon from '../../../common/base/Icon';
import Text from '../../../common/base/Text';
import Tooltip from '../../../common/base/Tooltip';
import SelectInput from '../../../common/Form/Fields/SelectInput';
import SwitchInput from '../../../common/Form/Fields/SwitchInput';
import TextInput from '../../../common/Form/Fields/TextInput';
import { Div } from '../../../common/helpers/StyledUtils';
import Modal from '../../../common/Modal';
import { useToasts } from '../../../common/Toast';
import { GlobalContext } from '../../../contexts/GlobalContext';
import { DashboardContext } from '../../DashboardScene/DashboardContext';
import { useOutpostConfigUpdate } from '../OutpostContext';
import { DestinationTopicsFields } from '../utils/outpostForms';
import { OPERATOR_EVENT_TOPIC_OPTIONS } from './OperatorEventDestinationSettings';
interface OperatorEventConfigFormValues {
  consecutive_failure_enabled: boolean;
  consecutive_failure_count: string;
  auto_disable_destination: boolean;
  exhausted_retries_enabled: boolean;
  exhausted_retries_window_seconds: string;
}
const AlertsSection: React.FC = () => {
  const $ = _c(11);
  const {
    config,
    updateConfig
  } = useOutpostConfigUpdate();
  const t0 = config.ALERT_CONSECUTIVE_FAILURE_COUNT !== "";
  const t1 = config.ALERT_CONSECUTIVE_FAILURE_COUNT ?? "";
  const t2 = config.ALERT_AUTO_DISABLE_DESTINATION === "true";
  const t3 = config.ALERT_EXHAUSTED_RETRIES_WINDOW_SECONDS !== "";
  const t4 = config.ALERT_EXHAUSTED_RETRIES_WINDOW_SECONDS ?? "";
  let t5;
  if ($[0] !== t0 || $[1] !== t1 || $[2] !== t2 || $[3] !== t3 || $[4] !== t4) {
    t5 = {
      consecutive_failure_enabled: t0,
      consecutive_failure_count: t1,
      auto_disable_destination: t2,
      exhausted_retries_enabled: t3,
      exhausted_retries_window_seconds: t4
    };
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== updateConfig) {
    t6 = async values_0 => {
      const result = await updateConfig({
        ALERT_CONSECUTIVE_FAILURE_COUNT: !values_0.consecutive_failure_enabled ? "" : values_0.consecutive_failure_count === "" ? null : values_0.consecutive_failure_count,
        ALERT_AUTO_DISABLE_DESTINATION: values_0.auto_disable_destination ? "true" : "false",
        ALERT_EXHAUSTED_RETRIES_WINDOW_SECONDS: !values_0.exhausted_retries_enabled ? "" : values_0.exhausted_retries_window_seconds === "" ? null : String(values_0.exhausted_retries_window_seconds)
      }, {
        success: "Alert configuration updated",
        failure: "Failed to update alert configuration"
      });
      if (!result) {
        return;
      }
    };
    $[6] = updateConfig;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = <Container medium={true} left={true}><Formik enableReinitialize={true} initialValues={t5} validate={_temp} onSubmit={t6}>{_temp2}</Formik></Container>;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
interface DestinationFormValues {
  type: string;
  all_topics: boolean;
  topics: string[];
  config: Record<string, string>;
  credentials: Record<string, string>;
}
const FieldList: React.FC<{
  fields: OutpostDestinationTypeField[];
  prefix: string;
}> = t0 => {
  const $ = _c(7);
  const {
    fields,
    prefix
  } = t0;
  if (!fields || fields.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== fields || $[1] !== prefix) {
    let t2;
    if ($[3] !== prefix) {
      t2 = field => {
        const field_name = `${prefix}.${field.key}`;
        return <TextInput key={field_name} name={field_name} label={field.label} help={field.description} placeholder={field.default || ""} required={field.required} type={field.sensitive ? "password" : "text"} />;
      };
      $[3] = prefix;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = fields.map(t2);
    $[0] = fields;
    $[1] = prefix;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[5] !== t1) {
    t2 = <>{t1}</>;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const HookdeckDestinationFields: React.FC = () => {
  const $ = _c(8);
  const {
    teams
  } = useContext(DashboardContext);
  let t0;
  bb0: {
    if (!teams) {
      let t1;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = [];
        $[0] = t1;
      } else {
        t1 = $[0];
      }
      t0 = t1;
      break bb0;
    }
    let t1;
    if ($[1] !== teams) {
      t1 = teams.filter(_temp3).map(_temp4);
      $[1] = teams;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = t1;
  }
  const project_options = t0;
  let t1;
  if ($[3] !== project_options) {
    t1 = <SelectInput block={true} name="config.team_id" label="Hookdeck project" placeholder="Select a project" options={project_options} />;
    $[3] = project_options;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <TextInput name="config.name" label="Source name" help="Name for the managed source that will be created in the selected project." placeholder="hookdeck-outpost" format={field_formats.slugify} required={true} />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1) {
    t3 = <>{t1}{t2}</>;
    $[6] = t1;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
const DestinationTypeFields: React.FC<{
  destination_types: OutpostDestinationTypeMetadata[];
}> = t0 => {
  const $ = _c(13);
  const {
    destination_types
  } = t0;
  const {
    values
  } = useFormikContext();
  let t1;
  if ($[0] !== destination_types || $[1] !== values) {
    let t2;
    if ($[3] !== values) {
      t2 = dt => dt.type === values.type;
      $[3] = values;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = destination_types.find(t2);
    $[0] = destination_types;
    $[1] = values;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const selected_type = t1;
  if (!selected_type) {
    return null;
  }
  if (selected_type.type === "hookdeck") {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <HookdeckDestinationFields />;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] !== selected_type.config_fields) {
    t2 = selected_type.config_fields.length > 0 && <FieldList fields={selected_type.config_fields} prefix="config" />;
    $[6] = selected_type.config_fields;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== selected_type.credential_fields) {
    t3 = selected_type.credential_fields.length > 0 && <><Text semi={true} size="m" m={{
        t: 4,
        b: 2
      }}>Credentials</Text><FieldList fields={selected_type.credential_fields} prefix="credentials" /></>;
    $[8] = selected_type.credential_fields;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t2 || $[11] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};
const DestinationTypeIcon: React.FC<{
  svg: string;
}> = t0 => {
  const $ = _c(4);
  const {
    svg
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "center",
      justify: "center"
    };
    t2 = {
      width: 16,
      height: 16
    };
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== svg) {
    t3 = <Div flex={t1} style={t2} dangerouslySetInnerHTML={{
      __html: svg
    }} />;
    $[2] = svg;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
const DestinationCard: React.FC<{
  destination: OutpostDestination;
  type_meta?: OutpostDestinationTypeMetadata;
}> = t0 => {
  const $ = _c(21);
  const {
    destination,
    type_meta
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      x: 4,
      y: 3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      justify: "space-between",
      align: "center"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      direction: "column",
      gap: 1
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      align: "center",
      gap: 2
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== type_meta) {
    t5 = type_meta?.icon && <DestinationTypeIcon svg={type_meta.icon} />;
    $[4] = type_meta;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const t6 = type_meta?.label || destination.type;
  let t7;
  if ($[6] !== t6) {
    t7 = <Text size="s" semi={true}>{t6}</Text>;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== t5 || $[9] !== t7) {
    t8 = <Div flex={t4}>{t5}{t7}</Div>;
    $[8] = t5;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== destination.target) {
    t9 = <Text muted={true} size="s">{destination.target}</Text>;
    $[11] = destination.target;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t8 || $[14] !== t9) {
    t10 = <Div flex={t3}>{t8}{t9}</Div>;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const t11 = `/settings/project/monitoring/${destination.id}`;
  let t12;
  if ($[16] !== t11) {
    t12 = <Button.Permission to={t11} outline={true} icon="link" />;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t10 || $[19] !== t12) {
    t13 = <StyledCard p={t1}><StyledCardSection flex={t2}>{t10}{t12}</StyledCardSection></StyledCard>;
    $[18] = t10;
    $[19] = t12;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  return t13;
};
const AddDestinationModal: React.FC<{
  destination_types: OutpostDestinationTypeMetadata[];
  onClose: () => void;
  onCreated: () => void;
}> = ({
  destination_types,
  onClose,
  onCreated
}) => {
  const {
    HookdeckAPI,
    configs
  } = useContext(GlobalContext);
  const {
    addToast
  } = useToasts();
  const type_options = destination_types.map(dt => ({
    label: dt.label,
    value: dt.type,
    icon: dt.icon ? <DestinationTypeIcon svg={dt.icon} /> : undefined
  }));
  return <Formik<DestinationFormValues> initialValues={{
    type: '',
    all_topics: true,
    topics: [],
    config: {},
    credentials: {}
  }} onSubmit={async (values, {
    setFieldError
  }) => {
    try {
      if (values.type === 'hookdeck') {
        const team_id = values.config.team_id;
        const name = values.config.name || 'hookdeck-outpost';
        const team_api = new HookdeckAPIClient(configs.API_URL, team_id);
        const is_name_used = await team_api.sources.nameIsUsed(name);
        if (is_name_used) {
          setFieldError('config.name', 'Source name is already in use');
          return;
        }
        const source = await team_api.sources.create({
          name,
          type: 'MANAGED',
          config: {}
        });
        const token = (source.config.auth as ManagedTokenIntegrationConfigs).token;
        const resolved_topics = values.all_topics ? ['*'] : values.topics;
        await HookdeckAPI.outpost.operatorEvents.destinations.create({
          type: 'hookdeck',
          topics: resolved_topics,
          config: {},
          credentials: {
            token
          }
        });
      } else {
        const resolved_topics_0 = values.all_topics ? ['*'] : values.topics;
        await HookdeckAPI.outpost.operatorEvents.destinations.create({
          type: values.type,
          topics: resolved_topics_0,
          config: values.config,
          credentials: Object.keys(values.credentials).length > 0 ? values.credentials : undefined
        });
      }
      onCreated();
      addToast('success', 'Operator event destination created');
      onClose();
    } catch {
      addToast('error', 'Failed to create operator event destination');
    }
  }}>
      {props => <Form>
          <Modal title="Add operator event destination" submit_label="Add destination" cancel_label="Cancel" onSubmit={props.handleSubmit} onClose={onClose} is_submitting={props.isSubmitting} submit_disabled={!props.values.type}>
            <SelectInput block name="type" label="Destination type" placeholder="Select a destination type" options={type_options} />
            <DestinationTypeFields destination_types={destination_types} />
            {props.values.type && <DestinationTopicsFields topic_options={OPERATOR_EVENT_TOPIC_OPTIONS} form_values={props.values} />}
          </Modal>
        </Form>}
    </Formik>;
};
const OperatorEventDestinationsSection: React.FC = () => {
  const $ = _c(24);
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const [show_add_modal, set_show_add_modal] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = APIMethodKeys.outpost.operatorEvents.destinationTypes.list();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== HookdeckAPI.outpost.operatorEvents.destinationTypes) {
    t1 = () => HookdeckAPI.outpost.operatorEvents.destinationTypes.list();
    $[1] = HookdeckAPI.outpost.operatorEvents.destinationTypes;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: destination_types
  } = useSWR(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = APIMethodKeys.outpost.operatorEvents.destinations.list();
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== HookdeckAPI.outpost.operatorEvents.destinations) {
    t3 = () => HookdeckAPI.outpost.operatorEvents.destinations.list();
    $[4] = HookdeckAPI.outpost.operatorEvents.destinations;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    data: operator_event_destinations,
    mutate: mutate_destinations
  } = useSWR(t2, t3);
  let t4;
  if ($[6] !== destination_types) {
    t4 = (destination_types || []).reduce(_temp6, {} as Record<string, OutpostDestinationTypeMetadata>);
    $[6] = destination_types;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const types_by_type = t4;
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Text bold={true} size="l" as="h2" m={{
      b: 0
    }}>Operator Events</Text>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Text m={{
      b: 4
    }} muted={true}>Alerts and tenant lifecycle events are delivered to your systems as operator events. Configure a destination to enable them.</Text>;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      direction: "column",
      gap: 4
    };
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== operator_event_destinations || $[12] !== types_by_type) {
    t8 = operator_event_destinations?.map(dest => <DestinationCard key={dest.id} destination={dest} type_meta={types_by_type[dest.type]} />);
    $[11] = operator_event_destinations;
    $[12] = types_by_type;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <PlaceholderButton.Permission p={{
      x: 4,
      y: 4
    }} onClick={() => set_show_add_modal(true)}>Add destination</PlaceholderButton.Permission>;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t8) {
    t10 = <Div flex={t7}>{t8}{t9}</Div>;
    $[15] = t8;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== destination_types || $[18] !== mutate_destinations || $[19] !== show_add_modal) {
    t11 = show_add_modal && destination_types && <AddDestinationModal destination_types={destination_types} onClose={() => set_show_add_modal(false)} onCreated={() => mutate_destinations()} />;
    $[17] = destination_types;
    $[18] = mutate_destinations;
    $[19] = show_add_modal;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <Container medium={true} left={true}>{t5}{t6}{t10}{t11}</Container>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};
const OperatorEventsSettings: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <AlertsSection />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <>{t0}<Div m={{
        x: 6,
        y: 6
      }}><Divider /></Div><OperatorEventDestinationsSection /></>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default OperatorEventsSettings;
function _temp(values) {
  const errors = {};
  if (values.consecutive_failure_enabled && values.consecutive_failure_count !== "" && !/^[1-9][0-9]*$/.test(values.consecutive_failure_count)) {
    errors.consecutive_failure_count = "Must be a positive whole number";
  }
  if (values.exhausted_retries_enabled && values.exhausted_retries_window_seconds !== "" && !/^[0-9]+$/.test(String(values.exhausted_retries_window_seconds))) {
    errors.exhausted_retries_window_seconds = "Must be a whole number of seconds";
  }
  return errors;
}
function _temp2(props) {
  return <Form><Text bold={true} size="l" as="h2" m={{
      y: 0
    }}>Alerts</Text><Text m={{
      b: 4
    }} muted={true}>Alert on tenants' destination delivery failures.</Text><StyledCard m={{
      b: 4
    }}><StyledCardSection flex={{
        justify: "flex-start",
        align: "center",
        gap: 3
      }} p={{
        x: 4,
        y: 3
      }}><SwitchInput name="consecutive_failure_enabled" /><Div flex={{
          align: "center",
          gap: 1
        }}><Text semi={true}>Consecutive failures</Text><Tooltip tooltip="Consecutive delivery failures are tracked per destination."><Icon muted={true} icon="info" /></Tooltip></Div></StyledCardSection>{props.values.consecutive_failure_enabled && <><StyledCardSection p={{
          x: 4,
          y: 4
        }}><TextInput m={0} name="consecutive_failure_count" label="Failure threshold" help="Alerts fire at 50%, 70%, 90%, and 100% of the threshold." placeholder="100" min={1} type="number" /></StyledCardSection><StyledCardSection flex={{
          justify: "flex-start",
          align: "center",
          gap: 3
        }} p={{
          x: 4,
          y: 3
        }}><SwitchInput name="auto_disable_destination" /><Div flex={{
            align: "center",
            gap: 1
          }}><Text>Auto-disable destination at threshold</Text><Tooltip tooltip="Automatically disable the tenant's destination when consecutive failures reach 100% of the threshold."><Icon muted={true} icon="info" /></Tooltip></Div></StyledCardSection></>}</StyledCard><StyledCard m={{
      b: 4
    }}><StyledCardSection flex={{
        justify: "flex-start",
        align: "center",
        gap: 3
      }} p={{
        x: 4,
        y: 3
      }}><SwitchInput name="exhausted_retries_enabled" /><Div flex={{
          align: "center",
          gap: 1
        }}><Text semi={true}>Exhausted retries</Text><Tooltip tooltip="Alert when an event delivery exhausts all retries."><Icon muted={true} icon="info" /></Tooltip></Div></StyledCardSection>{props.values.exhausted_retries_enabled && <StyledCardSection p={{
        x: 4,
        y: 4
      }}><TextInput m={0} name="exhausted_retries_window_seconds" label="Deduplication window (seconds)" help="At most one exhausted-retries alert per destination within this window. 0 = alert on every exhaustion." placeholder="0" min={0} type="number" /></StyledCardSection>}</StyledCard><Button.Permission primary={true} disabled={!props.dirty || props.isSubmitting} submit={true} icon={props.isSubmitting ? "loading" : "save"}>Save</Button.Permission></Form>;
}
function _temp3(t) {
  return t.type !== "outpost";
}
function _temp4(t_0) {
  return {
    label: t_0.name,
    value: t_0.id,
    icon: t_0.private ? "folder_private" as const : "folder" as const
  };
}
function _temp6(acc, dt) {
  acc[dt.type] = dt;
  return acc;
}